/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject.js";
import TagItem from "@shared/Tags/TagItem";
import {Type} from "class-transformer";


export default class TagsContainer extends DbBaseObject{

	@Type(() => TagItem)
	tagItems: TagItem[] = []




	constructor() {
		super();
	}

	getCurrentSchemaVersion(): number {
		return 2
	}


	filter(query){
		console.log("filter tags = ", this.tagItems)
		let lwQuery = (query || "").toLowerCase()
		return this.tagItems.filter(tagItem => {
			let res = false;
			try{
				res = query == null || tagItem.title.toLowerCase().indexOf(lwQuery) >= 0
			}catch (e){
				console.error(e)
				this.removeTag(tagItem)
			}
			return res
		})
	}


	addNewTags(tags){
		tags.forEach(newTag => {
			newTag.usageCounter++
			if(!this.tagItems.find(tag => tag.title === newTag.title)){
				this.tagItems.unshift(newTag)
			}
		})
	}

	removeTag(tag){
		let index = this.tagItems.indexOf(tag)
		this.tagItems.splice(index, 1);
	}

	updateTag(tag){
		let index = this.tagItems.indexOf(tag)
		this.tagItems.splice(index, 1, tag);
	}

	migrateSchema(oldVersion, newVersion) {
		super.migrateSchema(oldVersion, newVersion)
		if(oldVersion < 2){
			if(this.tags){
				this.tags.forEach(tagName => this.tagItems.push(new TagItem(tagName)))
				this.tags = []
			}
		}
	}

	toString(){
		return this.title
	}
}
